/**
 * 手机国际区号与号码校验（注册/登录等按需引用）。
 * 新增区号：在本数组追加一项即可。
 */
export interface PhoneDialCodeConfig {
  /** E.164 国家码前缀，如 +86 */
  dialCode: string
  /** 区号选择器展示文案，默认同 dialCode */
  label?: string
  /** 校验用户输入的「国内号码」去掉非数字后的形态（不含国家码） */
  nationalDigitsPattern: RegExp
  /** pattern 未通过时 i18n key，缺省为 0db00d4c */
  invalidMessageLngKey?: string
}

const digitsOnly = (raw: string) => raw.replace(/\D/g, '')

export const PHONE_DIAL_CODES: readonly PhoneDialCodeConfig[] = [
  { dialCode: '+86', nationalDigitsPattern: /^\d{11}$/ },
  { dialCode: '+81', nationalDigitsPattern: /^\d{10,11}$/ },
  { dialCode: '+82', nationalDigitsPattern: /^\d{9,11}$/ },
  { dialCode: '+852', nationalDigitsPattern: /^\d{8}$/ },
  { dialCode: '+853', nationalDigitsPattern: /^\d{7,8}$/ },
  { dialCode: '+886', nationalDigitsPattern: /^\d{8,10}$/ },
  { dialCode: '+61', nationalDigitsPattern: /^\d{9,10}$/ },
  { dialCode: '+44', nationalDigitsPattern: /^\d{10,11}$/ },
  { dialCode: '+1', nationalDigitsPattern: /^\d{10}$/ },
] as const

export const DEFAULT_PHONE_DIAL_CODE = PHONE_DIAL_CODES[0].dialCode

export function getPhoneDialConfig(dialCode?: string): PhoneDialCodeConfig {
  return PHONE_DIAL_CODES.find((c) => c.dialCode === dialCode) ?? PHONE_DIAL_CODES[0]
}

/** 区号下拉 options */
export function getPhoneDialSelectOptions() {
  return PHONE_DIAL_CODES.map((c) => ({
    value: c.dialCode,
    label: c.label ?? c.dialCode,
  }))
}

/** 发给验证码/注册接口：区号 + 号码（号码侧去掉非数字，无空格） */
export function formatPhoneAccount(dialCode: string | undefined, nationalRaw: string): string {
  const cfg = getPhoneDialConfig(dialCode)
  return `${cfg.dialCode}${digitsOnly(nationalRaw)}`
}

/** 用于表单 validator：去非数字后是否满足当前区号规则 */
export function isNationalNumberValid(dialCode: string | undefined, nationalRaw: string): boolean {
  const cfg = getPhoneDialConfig(dialCode)
  const compact = digitsOnly(nationalRaw)
  return cfg.nationalDigitsPattern.test(compact)
}
